import type { paths } from '@crossbeam/openapi';

import { createOpenApiHttp } from 'openapi-msw';

import appConfig from '@/config';

/** Lives apart from the mock entry point so a handler can reach it without
 * importing the module that loads the handlers. */
const typedHttp = createOpenApiHttp<paths>({
  baseUrl: appConfig.apiBaseUrl,
});

export { typedHttp };
